import { Button } from 'antd';

export default function ListingAgreementNotification({ onBtnClick }) {
  return (
    <div className='d-flex flex-column align-items-flex-end'>
      <p>To participate in trading shares, you must review and agree to our Secondary Listing Agreement Terms.</p>
      <Button type='primary' onClick={onBtnClick}>
        View
      </Button>
    </div>
  );
}
